import FavoritesApi from '@/api/favoritesApi'
import ApplicationsApi from '@/api/applicationApi'


const fav_api = new FavoritesApi()
const api = new ApplicationsApi()


import common from '@/store/mutations/common'


export default {
  methods: {
    removeApp(item) {
      item = item?.number ? item : this.application
      api.deleteApplication(item.id).then(() => {
        this.$root.$emit('showTemplateNotification', {
          remove: true,
          name: '"#' + item.number + '.  ' + ( item.title || this.$t('Catalog.NewPurchase')) + '"' } )
        this.$emit('removeApp', item)
      }).catch(error => this.$log_error(error.message))
    },
    removeApps() {
      const items = this.options.elements
      const promises = items.map( async item => {
        return await api.deleteApplication(item.id)
      })
      Promise.all(promises).then(() => {
        this.$root.$emit('showTemplateNotification', {
          remove: true,
          name: this.$t('Common.SelectedItems') } )
        this.options.removeDraft(items)
      }).catch(error => this.$log_error(error.message))
    },
    toggleTemplate() {
      if ( this.application.inTemplates ) {
        this.deleteFromTemplate()
      } else {
        this.saveAsTemplate()
      }
    },
    saveAsTemplate(item) {
      item = item?.number ? item : this.application
      fav_api.addToFavorite(item.id).then(res => {
        if ( res ) {
          item.inTemplates = true
        }

        this.$notice.info({
          title: this.$t('Common.AddedToTemplates', {item: this.$t('Menu.Purchasing') }),
          message: this.$t('Common.AddedToTemplatesText', {name: '#' + item.number + ' ' + (item.title || this.$t('Catalog.NewPurchase')), item: this.$t('Menu.Purchasing')}),
          duration: 10
        })
        setTimeout(() => {
          this.$emit('saveAsTemplate', item)
        }, 1000)
      })
        .catch(error => this.$log_error(error.message))
    },
    saveItemswAsTemplate(items) {
      items = items || this.options.elements
      const promises = items.map( async item => {
        return await fav_api.addToFavorite(item.id).then(res => {
          if ( res ) {
            item.inTemplates = true
          }
        })
      })
      Promise.all(promises).then(() => {
        this.$notice.info({
          title: this.$t('Common.AddedToTemplates', {item: this.$t('Menu.Purchasing') }),
          message: this.$t('Common.AddedToTemplatesText',
            {name: items.map(item => '#' + item.number + ' ' + (item.title || this.$t('Catalog.NewPurchase'))).join(', '), item: this.$t('Menu.Purchasing')}),
          duration: 10
        })
        this.options.saveAsTemplate(items)
      }).catch(error => this.$log_error(error.message))
    },
    deleteFromTemplate(item) {

      item = item?.number ? item : this.application
      fav_api.deleteItem(item.id).then(res => {
        if ( res ) {
          item.inTemplates = false
        }

        this.$notice.info({
          title: this.$t('Common.AddedToTemplates', {item: this.$t('Menu.Purchasing') }),
          message: this.$t('Common.RemovedFromTemplatesText',
            {name: '#' + item.number + ' ' + (item.title || this.$t('Catalog.NewPurchase')), item: this.$t('Menu.Purchasing')}),
          duration: 10
        })

        setTimeout(() => {
          this.$emit('deleteFromTemplate', item)
        }, 1000)
      })
        .catch(error => this.$log_error(error.message))
    },
    deleteItemsFromTemplate(items) {
      items = items || this.options.elements
      const promises = items.map( async item => {
        return await fav_api.deleteItem( item.id).then(res => {
          if ( res ) {
            item.inTemplates = false
          }
        })
      })
      Promise.all(promises).then(() => {

        this.$notice.info({
          title: this.$t('Common.AddedToTemplates', {item: this.$t('Menu.Purchasing') }),
          message: this.$t('Common.RemovedFromTemplatesText',
            {name: items.map(item => '#' + item.number + ' ' + (item.title || this.$t('Catalog.NewPurchase'))).join(', '), item: this.$t('Menu.Purchasing')}),
          duration: 10
        })

        setTimeout(() => {
          this.options.deleteFromTemplate(items)
        }, 1000)

      }).catch(error => this.$log_error(error.message))
    },
    $_copyApp() {
      let item = this.application || this.options.elements[0]
      this.$root.$emit('showOverlay')
      api.duplicateApplication(item.id)
        .then(res => {
          this.$router.push({name: 'editing',
            query: {id: res.data.duplicateApplication.id} ,
            params: {org: this.$route.params.org} })
        })
        .finally(() => this.$root.$emit('closeOverlay'))
    },
    async fillAcceptors(apps) {
      let withAccesoors = apps?.filter(el =>
        el.state != 'П' || el.status?.id != 'W'
      )
      let ids = withAccesoors?.map(el => el.id).reverse()

      if ( !ids?.length) { return }

      let setAcceptors = resps => {
        if (!resps?.length) {
          apps.forEach(el => this.$set(el, 'acceptors' ,  []))
        }
        resps?.forEach(resp => {
          let result = common._returnIndexById(apps, resp.undoc || resp)
          if (result.success) {
            this.$set(apps[result.returned], 'acceptors' , resp.acceptors || [])
          }
        })
      }

      await api.getAcceptorsByIds(ids )
        .then( setAcceptors )
        .catch( res => this.$log_error(res))

      // }
    },
    async fillCreators(apps) {
      let with_creator = apps?.filter(el => el.creator)
      if ( with_creator?.length ) {
        this.$store.dispatch('getUsers', with_creator.map(el => el.creator) )
          .then(res => {
            with_creator.forEach(app => {
              this.$set(app, 'creatorObject', res.find(el => el.id == app.creator) )
              this.$store.commit('editApplicationData', app)
            })
          })
      }
      apps?.filter(el => el.creatorUserId)?.forEach(async app => {
        this.$set(app, 'creatorObject',
          {
            fullName: app.creatorFIO,
            avatar: app.creatorAvatar,
            id: app.creatorUserId,
            department: {
              id: app.senderDepartmentId,
              name: app.senderDepartmentName
            }
          } )
      })
    },

    async getApp(id) {
      return await api.getApplicationById(id)
        .then(res => {
          if (!res.data.applications || !res.data.applications.length ) {
            this.$router.push({name: 'page-error', params: { status_code: 404, descript: 'applicationMixin'}})
          }
          return    this.$_.head(res.data.applications)
        })
    },

    // get
  }
}
